module.exports = __webpack_public_path__ + "static/media/click-11.53b166d4.mp3";